<template>
  <div class="gotoshop">
    <a href="https://b2b.baidu.com/aitf/shop?name=%E5%A8%B2%E7%9F%B3%E6%B0%B4%E6%B3%A5%E9%9B%86%E5%9B%A2%E6%9C%89%E9%99%90%E5%85%AC%E5%8F%B8&tpath=index" target="_blank">跳转商城</a>
    
  </div>
</template>

<script>
export default {

}
</script> 

<style lang="less" scoped>
*{
    padding: 0;margin: 0;
}
.gotoshop{
    width: 80px;
    height: 50px;
    line-height: 50px;
    color: #fff;
    background-color: #46739f;
    position: fixed;
    right: 20px;
    bottom: 50%;
    cursor: pointer;
    z-index: 99999;
}
</style>